import { useState } from 'react'
import { ContactComponent, FooterComponent, SelectDestionations } from '../components'
import '../styles/pages/shuttles.css'
import { shuttlePrice } from '../helpers/shuttlePrice'

export const ShuttlesPage = () => {
  const [ price, setPrice ] = useState(0)

  const calculatePrice = () => {
    const departure = document.getElementById('shuttle-departure-select');
    const destination = document.getElementById('shuttle-destination-select');
    setPrice( shuttlePrice(departure.value, destination.value) );
  }
  return (
    <>
        <div className='circuits'>
            {/* <h3>Próximamente...</h3>
            <div className="spinner-border" role='status'>
                <span className="sr-only">Loading...</span>
            </div> */}
            <div className="shuttle-form">
              <div className="shuttle-departure">
                <h4>Salida</h4>
                <select name="shuttle-departure" id="shuttle-departure-select" className='form-select'>
                  <SelectDestionations />
                </select>
              </div>
              <div className="shuttle-departure">
                <h4>Destino</h4>
                <select name="shuttle-destination" id="shuttle-destination-select" className='form-select' onBlur={ calculatePrice }>
                  <SelectDestionations />
                </select>
              </div>
              <div className="shuttle-price">
                <h4>Precio por persona</h4>
                {
                  price > 0 ?
                    (<p>USD { price.toFixed(2) }</p>) :
                    (<p>not available</p>)
                }
              </div>
              <div className="shuttle-reservation">
                <h4 className='ocultar'>Reservar</h4>
                <button className="btn btn-success">Reservar</button>
              </div>
            </div>
        </div>
        <ContactComponent />
        <FooterComponent />
    </>
  )
}
